<div class="gc-shell">
  <!-- ══ HEADER ══ -->
  <div class="gc-header">
    <div class="gc-header__scanlines"></div>
    <div class="gc-header__inner d-flex align-items-center justify-content-between px-3">
      <div class="gc-header__brand d-flex align-items-center gap-2">
        <span class="gc-header__icon bi bi-controller"></span>
        <span class="gc-header__title">{{ 'CHALLENGES.WAGERS_TITLE' | translate }}</span>
        <span class="gc-header__live-dot"></span>
      </div>

      <!-- xs only: dropdown -->
      <div class="gc-select-xs">
        <mat-form-field appearance="outline" class="gc-mat-select">
          <mat-select [(ngModel)]="selectedTab" name="tabFilter" (selectionChange)="onTabChange($event)">
            <ng-container *ngFor="let tab of tabs">
              <mat-option *ngIf="tab === 'AVAILABLE' ? showChallenges : true" [value]="tab">
                {{ 'CHALLENGES.' + tab + '_TAB_TITLE' | translate }}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- ══ TAB NAV ══ -->
  <div class="gc-tabs d-flex">
    <ng-container *ngFor="let tab of tabs">
      <button
        *ngIf="tab === 'AVAILABLE' ? showChallenges : true"
        class="gc-tab"
        [class.gc-tab--active]="selectedTab === tab"
        (click)="selectedTab = tab; challengeWagerList.scrollTop = 0"
      >
        <span
          class="gc-tab__icon bi"
          [ngClass]="{
            'bi-hourglass-split': tab === 'PROPOSALS',
            'bi-lightning-charge-fill': tab === 'ACTIVE',
            'bi-trophy-fill': tab === 'AVAILABLE',
            'bi-clock-history': tab === 'HISTORY'
          }"
        ></span>
        <span class="gc-tab__label">{{ 'CHALLENGES.' + tab + '_TAB_TITLE' | translate }}</span>
        <span class="gc-tab__count" *ngIf="wagers[tab]?.items?.length">{{ wagers[tab].items.length }}</span>
      </button>
    </ng-container>
  </div>

  <!-- ══ CONTENT ══ -->
  <div class="gc-body" #challengeWagerList>
    <div *ngIf="isLoadingChallenges || wagers[selectedTab].isLoading" class="gc-loader" [@fadeInOut]>
      <mat-spinner diameter="32" mode="indeterminate"></mat-spinner>
      <span class="gc-loader__text">LOADING…</span>
    </div>

    <ng-container *ngIf="['PROPOSALS', 'ACTIVE', 'HISTORY'].includes(selectedTab)">
      <ng-container *ngTemplateOutlet="wagersTemplate; context: { tab: selectedTab }"></ng-container>
    </ng-container>

    <ng-container *ngIf="selectedTab === 'AVAILABLE'">
      <app-challenges-table
        [selectedTab]="selectedTab"
        [challenges]="challenges"
        [isLoading]="isLoadingChallenges"
        [isLoadMore]="challengesLastKey"
        (onMakeWager)="toMakeWager($event)"
        (onLoadMore)="getGamificationChallenges(true)"
      ></app-challenges-table>
    </ng-container>
  </div>
</div>

<!-- ══════════════════════════════════════════════ -->
<ng-template #wagersTemplate let-tab="tab">
  <div class="table-responsive">
    <table class="gc-table w-100">
      <thead>
        <tr>
          <th class="col-st">{{ 'CHALLENGES.STATUS_TITLE' | translate }}</th>
          <th class="col-vs">{{ 'CHALLENGES.OPPONENTS_TITLE' | translate }}</th>
          <th class="col-vt">{{ 'CHALLENGES.BET_INITIATOR' | translate }}</th>
          <th class="col-pt">{{ 'CHALLENGES.RATE_TITLE' | translate }}</th>
          <th class="col-vt">{{ 'CHALLENGES.BET_OPPONENT' | translate }}</th>
          <th *ngIf="'PROPOSALS' === tab" class="col-ac">{{ 'CHALLENGES.ACTIONS_TITLE' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let wager of wagers[tab].items; trackBy: trackItem"
          [@listFadeInOut]="wagers[tab].items.length"
          [class.gc-row--win]="wager.winnerId && wager.winnerId === authHelper.userProfile.cognitoId"
          [class.gc-row--loss]="wager.winnerId && wager.winnerId !== authHelper.userProfile.cognitoId"
        >
          <!-- Status -->
          <td class="col-st">
            <span
              class="gc-status"
              [ngClass]="'gc-status--' + wager.status.toLowerCase()"
              [matTooltip]="wager.status | lowercase"
            >
              <mat-icon>{{ mapChallengeStatusToIcon[wager.status] }}</mat-icon>
            </span>
          </td>

          <!-- VS column -->
          <td class="col-vs">
            <div class="gc-vs">
              <div class="gc-vs__player">
                <div class="gc-avatar">
                  <app-s3-image
                    [isRounded]="true"
                    [image]="wager.initiator?.avatarUrl"
                    [avatarName]="wager.initiator?.username"
                  ></app-s3-image>
                </div>
                <span class="gc-vs__name">{{ wager.initiator?.username }}</span>
              </div>
              <span class="gc-vs__badge">VS</span>
              <div class="gc-vs__player gc-vs__player--right">
                <div class="gc-avatar">
                  <app-s3-image
                    [isRounded]="true"
                    [image]="wager.opponent?.avatarUrl"
                    [avatarName]="wager.opponent?.username"
                  ></app-s3-image>
                </div>
                <span class="gc-vs__name">{{ wager.opponent?.username }}</span>
              </div>
            </div>
          </td>

          <!-- Initiator vote -->
          <td class="col-vt">
            <div
              class="gc-vote"
              [class.gc-vote--win]="wager.initiatorId === authHelper.userProfile.cognitoId"
              [class.gc-vote--loss]="wager.opponentId === authHelper.userProfile.cognitoId"
            >
              <app-user-template
                class="icon-30"
                [user]="wager.initiatorVote"
                tooltipField="userData.status"
              ></app-user-template>
            </div>
          </td>

          <!-- Points / cost -->
          <td class="col-pt">
            <span
              class="gc-pts"
              [class.gc-pts--win]="wager.winnerId === authHelper.userProfile.cognitoId"
              [class.gc-pts--loss]="wager.winnerId && wager.winnerId !== authHelper.userProfile.cognitoId"
            >
              <span *ngIf="wager.winnerId">{{ wager.winnerId === authHelper.userProfile.cognitoId ? '+' : '-' }}</span>
              <i class="bi bi-coin"></i> {{ wager.cost }}
            </span>
          </td>

          <!-- Opponent vote -->
          <td class="col-vt">
            <div
              class="gc-vote"
              [class.gc-vote--win]="wager.opponentId === authHelper.userProfile.cognitoId"
              [class.gc-vote--loss]="wager.initiatorId === authHelper.userProfile.cognitoId"
            >
              <app-user-template
                class="icon-30"
                [user]="wager.opponentVote"
                tooltipField="userData.status"
              ></app-user-template>
            </div>
          </td>

          <!-- Actions -->
          <td *ngIf="'PROPOSALS' === tab" class="col-ac">
            <div
              class="d-flex gap-1"
              *ngIf="wager.status === 'PENDING' && authHelper.userProfile.cognitoId === wager.opponent.cognitoId"
            >
              <button
                mat-icon-button
                class="gc-btn gc-btn--accept"
                [tabIndex]="-1"
                (click)="changeChallengeWagerStatus(tab, wager.id, wager.challenge.id, 'ACCEPTED')"
                [matTooltip]="'BUTTON.ACCEPT' | translate"
              >
                <mat-icon>check_circle_outline</mat-icon>
              </button>
              <button
                mat-icon-button
                class="gc-btn gc-btn--reject"
                [tabIndex]="-1"
                (click)="changeChallengeWagerStatus(tab, wager.id, wager.challenge.id, 'REJECTED')"
                [matTooltip]="'BUTTON.REJECT' | translate"
              >
                <mat-icon>remove_circle_outline</mat-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="!wagers[tab].items.length" class="gc-empty">
    <i class="bi bi-controller gc-empty__icon"></i>
    <span>{{ 'CHALLENGES.NO_WAGERS' | translate }}</span>
  </div>

  <div class="gc-sentinel" #loading>
    <span *ngIf="wagers[tab].items?.length && wagers[tab].isLoading" class="gc-loading-more">
      <mat-spinner diameter="14" mode="indeterminate"></mat-spinner> LOADING…
    </span>
  </div>
</ng-template>
